module.exports = __webpack_public_path__ + "media/images/products-img-03-20423a53db0d275b9b4ecbf51d6841a7.png";